import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

type UseStylesProps = {
	inputHeight: number
}

const useStyles = makeStyles(theme => ({
	messageContainer: {
		paddingBottom: theme.spacing(3),
		position: "relative"
	},
	currentMessageBeingEdited: {
		borderColor: colors.green[500]
	},
	messageListContent: {
		background: `linear-gradient(310deg, ${colors.purple[100]}, ${colors.beige[100]})`,
		padding: theme.spacing(1),
		overflowY: "auto",
		top: 0,
		flex: 1,
		width: "100%",
		bottom: 0,
		position: "absolute"
	},
	messageActionContainer: {
		maxWidth: 48
	},
	messageActionButton: {
		background: `linear-gradient(310deg, ${colors.purple[50]}, ${colors.beige[50]})`,
		color: colors.gray[400],
		"&:hover": {
			background: colors.gray[100],
			transform: "scale(1.02)"
		}
	},
	messageItem: {
		pointerEvents: "none"
	},
	messageButton: {
		textAlign: "inherit",
		[theme.breakpoints.down("sm")]: {
			flex: 1
		}
	},
	disabledMessageButton: {
		cursor: "text"
	},
	chatMessageBuilderContainer: {
		maxHeight: 500,
		height: "50vh",
		position: "relative",
		overflowY: "hidden",
		background: `linear-gradient(310deg, ${colors.purple[100]}, ${colors.beige[100]})`
	},
	messageListContainer: {
		position: "absolute",
		height: "100%",
		flex: 1,
		top: 0,
		transition: theme.transitions.create("all", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		})
	},
	messageListContainerInputVisible: {
		height: (props: UseStylesProps) => `calc(100% - ${props.inputHeight}px)`
	},
	messageListContainerInputInvisible: {
		height: "100%"
	},
	inputContainer: {
		// eslint-disable-next-line
		position: "absolute !important" as any,
		transition: theme.transitions.create("all", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		})
	},
	inputContainerVisible: {
		bottom: 0
	},
	inputContainerInvisible: {
		bottom: (props: UseStylesProps) => `-${props.inputHeight}px`
	},
	hiddenButton: {
		display: "none"
	},
	fadeInOutAnimation: {
		animation: "$fadeInOut 2s infinite"
	},
	customSecondaryTitleTextStyle: {
		maxHeight: 100,
		overflowY: "auto"
	}
}))

export default useStyles
